<template>
  <div id="home1">
    <div class="register_box">
      <div class="zcxingshi">
        <span
          @click="cl()"
          id="ge"
          :style="{ color: cur == 0 ? '#3562e8' : 'black' }"
          >个人用户注册</span
        >
        <!-- <div :class="{ gun: flag }"></div> -->
        <span
          @click="cl1()"
          :style="{ color: cur == 1 ? '#3562e8' : 'black' }"
          style="margin-left: 47px"
          >企业用户注册</span
        >
        <!-- <div :class="{ gun1: flag1 }"></div> -->
        <Button
          style="float: right; margin-right: 30px"
          type="primary"
          @click.native="gologin()"
          >返回</Button
        >
      </div>
      <div class="gzhuce" v-show="cur == 0">
        <div class="bujinqi">
          <Steps :current="num">
            <Step content="账号注册"></Step>
            <Step content="填写教材邮寄地址"></Step>
            <Step content="填写用户基本信息"></Step>
          </Steps>
        </div>

        <div class="xixin_zhuce" v-show="num == 0">
          <Form
            ref="formValidates"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="100"
            style="margin-top: 100px"
          >
            <FormItem label="身份证号码" prop="cardId">
              <Input
                @on-blur="checkRangeIdCard(formValidate.cardId)"
                v-model="formValidate.cardId"
                placeholder="请输入身份证号码"
              ></Input>
            </FormItem>
            <FormItem label="密码" prop="mail" style="margin-top: 40px">
              <Input
                type="password"
                v-model="formValidate.mail"
                placeholder="请输入密码"
                password 
              ></Input>
            </FormItem>
            <FormItem label="确认密码" prop="mail1" style="margin-top: 40px">
              <Input
                type="password"
                v-model="formValidate.mail1"
                @keydown.enter.native="nextze"
                placeholder="请确认密码"
                password 
              ></Input>
            </FormItem>
            <div class="prev_fapiao1" @click="nextze()">下一步</div>
          </Form>
        </div>
        <div class="xixin_jiben" v-show="num == 2">
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="100"
            :inline="true"
          >
            <FormItem label="姓名" prop="fullName">
              <Input
                style="width: 477px"
                v-model="formValidate.fullName"
                placeholder="请输入姓名"
              ></Input>
            </FormItem>

            <FormItem label="性别" prop="sex">
              <Select
                @on-change="cahnge1"
                style="width: 477px"
                v-model="formValidate.sex"
                placeholder=""
              >
                <Option value="nan">男</Option>
                <Option value="nv">女</Option>
              </Select>
            </FormItem>
            <FormItem label="执业地区">
              <Select
                v-model="formValidate.comProvince"
                style="width: 160px"
                placeholder="请选择省份"
                @on-change="changesheng(formValidate.province)"
              >
                <Option
                  v-for="(item, index) in provinceArr"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.comCity"
                style="width: 160px"
                placeholder="请选择城市"
                @on-change="changeCity(formValidate.comCity)"
              >
                <Option
                  v-for="(item, index) in citiesArr"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.comCounty"
                style="width: 160px"
                placeholder="请选择区县"
              >
                <Option
                  v-for="(item, index) in countyArr"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="工作单位">
              <Input
                style="width: 477px"
                v-model="formValidate.companyName"
                placeholder="请工作单位"
              ></Input>
            </FormItem>
            <FormItem label="执业范围">
              <Select v-model="formValidate.jobId" style="width: 477px">
                <Option
                  v-for="item in cityList"
                  :value="item.value"
                  :key="item.label"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="电子邮箱" prop="email">
              <Input
                style="width: 477px"
                v-model="formValidate.email"
                placeholder="请输入电子邮箱"
              ></Input>
            </FormItem>
            <FormItem label="所学专业">
              <Input
                style="width: 477px"
                v-model="formValidate.major"
                placeholder=""
              ></Input>
            </FormItem>
            <FormItem label="最高学历">
              <Select
                v-model="educationBackground"
                @on-change="cahnge1"
                style="width: 477px"
              >
                <Option
                  v-for="(item, index) in data"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="手机号" prop="mobile">
              <Input
                style="width: 477px"
                v-model="formValidate.mobile"
                placeholder="请输入手机号"
              ></Input>
            </FormItem>
            <FormItem label="验证码" prop="checkCode">
              <Input
                style="width: 372px"
                v-model="formValidate.checkCode"
                placeholder="请输入验证码"
              ></Input>
              <Button type="primary" @click="getCode()"
                >{{ codes }}<span v-show="flag">s后重新发送</span></Button
              >
            </FormItem>

            <!-- <FormItem label="证书">
              <div class="demo-upload-list" v-if="src">
                <template>
                  <img :src="src" class="register_ing" />
                  <div class="demo-upload-list-cover">
                    <Icon
                      type="ios-eye-outline"
                      @click.native="handleView()"
                    ></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native="handleRemove()"
                    ></Icon>
                  </div>
                </template>
              </div>
              <Upload
                :headers="{ 'Access-Control-Allow-Origin': '*' }"
                ref="upload"
                name="img"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :format="['jpg', 'jpeg', 'png', 'pdf', 'gif']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :on-success="handleBeforeUpload"
                multiple
                type="drag"
                action="http://47.102.129.43:8198/educationPCServer/oss/postfile"
                style="display: inline-block; width: 58px"
                class="Uploadaa"
              >
                <div class="Iconb">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload> -->
            <!-- 展示放大图片
              <Modal title="View Image" v-model="visible">
                <img v-if="visible" style="width: 100%" :src="src" />
              </Modal> -->
            <!-- </FormItem> -->
          </Form>
          <div class="next_xiaone" @click="sumbit('formValidate')">
            提交注册
          </div>
          <div class="prev_shangone" @click="prevze()">上一步</div>
        </div>
        <div class="xixin_youji" v-show="num == 1">
          <Form
            ref="addressdata"
            :model="formValidate"
            :rules="addressdata"
            :label-width="100"
            :inline="true"
          >
            <FormItem label="邮寄地址" prop="address">
              <Select
                v-model="formValidate.province1"
                style="width: 160px"
                placeholder="请选择省份"
                @on-change="changesheng1(formValidate.province1)"
              >
                <Option
                  v-for="(item, index) in provinceArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.city1"
                style="width: 160px"
                placeholder="请选择城市"
                @on-change="changeCity1(formValidate.city1)"
              >
                <Option
                  v-for="(item, index) in citiesArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.county1"
                style="width: 160px"
                placeholder="请选择区县"
                @on-change="getpost1(formValidate.county1)"
              >
                <Option
                  v-for="(item, index) in countyArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Input
                style="width: 300px"
                v-model="formValidate.address"
                placeholder="请输入邮寄地址"
              ></Input>
            </FormItem>
            <br />
            <FormItem label="邮编" prop="bian">
              <Input
                style="width: 477px"
                v-model="formValidate.bian"
                placeholder="请输入邮编"
              ></Input>
            </FormItem>
          </Form>
          <div class="prev_shang" @click="nextzee()">下一步</div>
          <div class="next_xia" @click="prevze()">上一步</div>
        </div>
        <!-- <div class="xixin_fapiao" v-show="num == 1" id="gerenfapiao">
          <Form
            ref="startdata"
            :model="formValidate"
            :rules="startdata"
            :label-width="110"
            :inline="true"
          >
            <FormItem label="开票类型" prop="kai">
              <Select v-model="formValidate.kai" style="width: 200px">
                <Option value="1">普通发票</Option>
              </Select>
            </FormItem>
            <br />
            <FormItem label="发票抬头" prop="tai">
              <Input
                style="width: 477px"
                v-model="formValidate.tai"
                placeholder=""
              ></Input>
            </FormItem>
            <br />
          </Form>
          <div class="prev_fapiao2" @click="prevze()">上一步</div>
          <div class="next_fapiao3" @click="nextxiayibu()">
            下一步
          </div>
        </div> -->
      </div>
      <div class="qiyezhuce" v-show="cur == 1">
        <div class="bujinqi">
          <!-- <Steps :current="rou"> -->
            <!-- <Step content="企业基本信息"></Step>
            <Step content="账号注册"></Step> -->
            <!-- <Step content="开票信息"></Step> -->
          <!-- </Steps> -->
        </div>
        <div class="qiye_zhuce" v-show="rou == 0">
          <Form
            ref="formValidatess"
            :model="qiyealidate"
            :rules="qiyejibendata"
            :label-width="120"
            :inline="true"
          >
            <FormItem label="单位名称" prop="dw">
              <Input
                style="width: 437px"
                v-model="qiyealidate.dw"
                placeholder="请输入单位名称"
              ></Input>
            </FormItem>
            <FormItem label="联系人电话" prop="dh">
              <Input
                style="width: 437px"
                v-model="qiyealidate.dh"
                placeholder="请输入联系人电话"
              ></Input>
            </FormItem>
            <br />
            <FormItem label="单位地址" prop="dz">
              <Select
                v-model="formValidate.province1"
                style="width: 145px"
                placeholder="请选择省份"
                @on-change="changesheng1(formValidate.province1)"
              >
                <Option
                  v-for="(item, index) in provinceArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.city1"
                style="width: 145px"
                placeholder="请选择城市"
                @on-change="changeCity1(formValidate.city1)"
              >
                <Option
                  v-for="(item, index) in citiesArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
              <Select
                v-model="formValidate.county1"
                style="width: 145px"
                placeholder="请选择区县"
                @on-change="getpost1(formValidate.county1)"
              >
                <Option
                  v-for="(item, index) in countyArr1"
                  :key="index"
                  :value="item.code"
                  >{{ item.text }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="详细地址" prop="qy">
              <Input
                style="width: 437px"
                v-model="qiyealidate.qy"
                placeholder="请输入详细地址"
              ></Input>
            </FormItem>
            
            <br />

            <FormItem label="邮政编码" prop="yb">
              <Input
              style="width: 437px"
                class="shuru"
                v-model="qiyealidate.yb"
                placeholder="请输入邮政编码"
              ></Input>
            </FormItem>
            <FormItem label="登录账号" prop="zh">
              <Input
              style="width: 437px"
                class="shuru"
                v-model="qiyealidate.zh"
                placeholder="请输入登录账号"
                @on-blur="Check(qiyealidate.zh)"
                @on-change="getname(qiyealidate.zh)"
              ></Input>
            </FormItem>
            <FormItem label="联系人姓名" prop="fz">
              <Input
              style="width: 437px"
                class="shuru"
                v-model="qiyealidate.fz"
                placeholder="请输入联系人姓名"
              ></Input>
            </FormItem>
            <FormItem label="密码" prop="mm">
              <Input
              style="width: 437px"
                type="password"
                class="shuru"
                v-model="qiyealidate.mm"
                placeholder="请输入密码"
                password
              ></Input>
            </FormItem>
            <FormItem label="密码确认" prop="qr">
              <Input
              style="width: 437px"
                type="password"
                class="shuru"
                v-model="qiyealidate.qr"
                placeholder="请确认密码"
                password
              ></Input>
            </FormItem>
            <br />
          </Form>
          <!-- <div class="prev_shangzhuce" @click="prevze()">上一步</div> -->
          <div class="next_xiazhuce" @click="nextzer()">提交注册</div>
        </div>
        <!-- <div class="qiye_jiben" v-show="rou == 1" id="bb"> -->
          <!-- <Form
            ref="startdata"
            :model="qiyealidate"
            :rules="qiyezhdata"
            :label-width="100"
            :inline="true"
          > -->
            
            <!-- <FormItem label="性别" prop="sex">
              <Select class="shuru" v-model="qiyealidate.sex" placeholder="">
                <Option value="nan">男</Option>
                <Option value="nv">女</Option>
              </Select>
            </FormItem> -->
          <!-- </Form>
          <div class="prev_shangqiye" @click="nextzeq()">下一步</div>
          <div class="next_xiaqiye" @click="prevzev()">上一步</div> -->
        <!-- </div> -->
        <!-- <div class="xixin_fapiao" v-show="rou == 2" id="qiyefapiao">
          <Form
            class="startdataa"
            ref="startdata"
            :model="qiyealidate"
            :rules="qiyekaidata"
            :label-width="100"
            :inline="true"
          >
            <FormItem label="开票类型" prop="kai">
              <Select v-model="qiyealidate.kai" class="kaipiaoa">
                <Option :value="0">普通发票</Option>
                <Option :value="1">专票</Option>
              </Select>
            </FormItem>
            <br />
            <FormItem label="发票抬头" prop="fp">
              <Input
                class="shuru"
                v-model="qiyealidate.fp"
                placeholder=""
              ></Input>
            </FormItem>
            <br />
            <FormItem v-if="qiyealidate.kai == 0" label="纳税识别号" prop="ns">
              <Input
                class="shuru"
                v-model="qiyealidate.ns"
                placeholder=""
              ></Input>
            </FormItem>
            <FormItem label="接收手机号">
              <Input
                class="shuru"
                v-model="qiyealidate.modile"
                placeholder="接受发票信息手机号"
              ></Input>
            </FormItem>
            <FormItem v-if="qiyealidate.kai == 1" label="开户行名称">
              <Input
                class="shuru"
                v-model="qiyealidate.bankBranchName"
                placeholder="开户行名称"
              ></Input>
            </FormItem>
            <FormItem v-if="qiyealidate.kai == 1" label="开户账号">
              <Input
                class="shuru"
                v-model="qiyealidate.bankAccount"
                placeholder="开户账号"
              ></Input>
            </FormItem>
            <FormItem v-if="qiyealidate.kai == 1" label="请输入纳税人识别号">
              <Input
                class="shuru"
                v-model="qiyealidate.identifyNumber"
                placeholder="请输入纳税人识别号"
              ></Input>
            </FormItem>
            <FormItem v-if="qiyealidate.kai == 1" label="地址">
              <Input
                class="shuru"
                v-model="qiyealidate.address"
                placeholder="地址"
              ></Input>
            </FormItem>
          </Form>
          <div class="prev_fapiao" @click="nextzew()">注册</div>
          <div class="next_fapiao" @click="prevzeb()">取消</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "components/common/Header";
import Area from "components/common1/area";

import {
  sendMessageToUser,
  register,
  checkRangeMobile,
  uniqueUsername,
  getCityList,
  checkRangeIdCard,
} from "network/home.js";
import { ItemImgList } from "common/minix";
import md5 from "js-md5";
export default {
  name: "Register",

  components: {
    NavBar,
  },

  mixins: [ItemImgList],

  data() {
    return {
      // mag:true,
      mag1:true,
      cityList: [
        {
          value: 1,
          label: "生产",
        },
        {
          value: 2,
          label: "经营",
        },
        {
          value: 3,
          label: "批发",
        },
        {
          value: 4,
          label: "使用",
        },
        {
          value: 5,
          label: "教育",
        },
        {
          value: 6,
          label: "科研",
        },
        {
          value: 7,
          label: "管理",
        },
        {
          value: 8,
          label: "其他",
        },
      ],
      flag: false,
      requiredd: true,
      loading: false,
      codes: "获取验证码",
      timer: null,
      rou: 0,
      provinceArr: [],
      citiesArr: [],
      countyArr: [],
      provinceArr1: [],
      citiesArr1: [],
      countyArr1: [],
      //个人
      formValidate: {
        province: "",
        county: "",
        province1: "",
        county1: "",
        city1: "",
        //身份证号码
        cardId: "",
        //密码
        mail: "",
        //确认密码
        mail1: "",
        city: "",

        //手机号
        mobile: "",
        yzm: "",
        yname: "",
        //性别
        sex: "",
        // 职称类别
        radio: 1,
        //姓名
        fullName: "",
        //执行地区
        workArea: "",
        //验证码
        checkCode: "",
        //执业范围
        jobName: "经营",
        //工作单位
        companyName: "",
        lei: "",
        educationBackground: "",
        //所学专业
        major: "",
        classify: "",
        ming: "",
        dizhi: "",
        //年龄
        age: "",
        //电话
        tel: "",
        //电子邮箱
        email: "",
        //邮寄地址
        address: "",
        //职务
        zhiwu: "",
        //邮编
        bian: "",
        //技术岗位
        gang: "",
        //开票类型
        kai: "",
        //发票抬头
        tai: "",
        //纳税人识别号
        hao: "",
      },
      //企业
      qiyealidate: {
        //账号
        zh: "",
        //手机号
        sj: "",
        //负责人姓名
        fz: "",
        //密码
        mm: "",
        //性别
        sex: "",
        //确认密码
        qr: "",
        //单位名称
        dw: "",
        //单位地址
        dz: "",
        //所属行政区域
        qy: "",
        //单位电话
        dh: "",
        //邮政编码
        yb: "",
        //开票类型
        kp: "",
        //发票抬头
        fp: "",
        //纳税识别号
        ns: "",
      },
      data: [
        {
          value: "8",
          label: "博士后",
        },
        {
          value: "7",
          label: "博士",
        },
        {
          value: "6",
          label: "硕士",
        },
        {
          value: "5",
          label: "本科",
        },
        {
          value: "4",
          label: "大专",
        },
        {
          value: "3",
          label: "高中",
        },
        {
          value: "2",
          label: "初中",
        },
        {
          value: "1",
          label: "小学",
        },
      ],
      ruleValidate: {
        cardId: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: "blur",
            width: 500,
          },
        ],
        sex: [
          {
            required: true,
            message: "性别不能为空",
            trigger: "blur",
          },
        ],
        fullName: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur",
          },
          {
            type: "string",
            message: "请输入不包含空格的字符",
            trigger: "blur",
            transform(value) {
              if (value && value.indexOf(" ") === -1) {
                return value;
              } else {
                return false;
              }
            },
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$/;
              console.log(passwordreg.test(value));
              if (!passwordreg.test(value)) {
                callback(
                  this.$message({
                    message: "密码必须由数字、字母和特殊字符(如!、#、$、%等)组成,请输入8-20位",
                    type: "warning",
                  })
                );
              } else {
                callback();
              }
            },
          },
        ],
        mail1: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "不符合手机号码规则",
            trigger: "blur",
          },
        ],
        email: [
          {
            message: "电子邮件不能为空",
            trigger: "blur",
          },
          { type: "email", message: "电子邮件格式不正确", trigger: "blur" },
        ],
        tel: [
          {
            type: "string",
            pattern: /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/,
            message: "请填写电话(座机格式'区号-座机号码')",
            trigger: "blur",
          },
        ],
        yzm: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        workArea: [
          {
            required: true,
            message: "执业地区不能为空",
            trigger: "blur",
          },
        ],
        checkCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        lei: [
          {
            required: true,
            message: "职业类别不能为空",
            trigger: "blur",
          },
        ],
      },
      addressdata: {
        address: [
          {
            required: true,
            message: "地址不能为空",
            trigger: "blur",
          },
        ],
        bian: [
          {
            message: "邮编不能为空",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /^[1-9]\d{5}$/,
            message: "不是正确的邮政编码",
            trigger: "blur",
          },
        ],
      },
      startdata: {
        kai: [
          {
            required: true,
            message: "开票类型不能为空",
            trigger: "blur",
          },
        ],
        tai: [
          {
            required: true,
            message: "发票抬头不能为空",
            trigger: "biur",
          },
        ],
      },
      qiyejibendata: {
        dw: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "biur",
          },
        ],
        dz: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: "blur",
          },
        ],
        qy: [
          {
            required: true,
            message: "请输入所属行政区域",
            trigger: "blur",
          },
        ],
        dh: [
          {
            required: true,
            message: "请输入电话或手机号",
            trigger: "blur",
          },
          {
            type: "string",
            trigger: "blur",
          },
        ],
        yb: [
          {
            required: true,
            message: "请输入邮政编码",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /^[1-9]\d{5}$/,
            message: "不是正确的邮政编码",
            trigger: "blur",
          },
        ],
        zh: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: "biur",
          },
        ],
        sj: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "不符合手机号码规则",
            trigger: "blur",
          },
        ],
        fz: [
          {
            required: true,
            message: "请输入负责人姓名",
            trigger: "blur",
          },
        ],
        mm: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$/;
              if (!passwordreg.test(value)) {
                callback(
                  this.$message({
                    message: "密码必须由数字、字母和特殊字符(如!、#、$、%等)组成,请输入8-20位",
                    type: "warning",
                  })
                );
              } else {
                callback();
              }
            },
          },
        ],
        // sex: [
        //   {
        //     required: true,
        //     message: "请选择性别",
        //     trigger: "blur",
        //   },
        // ],
        qr: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$/;
              if (!passwordreg.test(value)) {
                callback(
                  this.$message({
                    message: "密码必须由数字、字母和特殊字符(如!、#、$、%等)组成,请输入8-20位",
                    type: "warning",
                  })
                );
              } else {
                callback();
              }
            },
          },
        ],
      },
      qiyekaidata: {
        kp: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: "biur",
          },
        ],
        fp: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        ns: [
          {
            required: true,
            message: "请输入纳税识别号",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /[A-Z0-9]{5}/,
            message: "纳税号不符合格式(只允许输入数字+英文（大写）)",
            trigger: "blur",
          },
        ],
      },
      num: 0,
      cur: 0,

      isCode1: "",
      type: 0,
      educationBackground: 1,
      sex: "",
      visible: false,
      src: null,
      defaultList: [],
      parentId: "",
      stopSubmit: false,
      comProvincecode: "", //省编码
      comCitycode: "", //市编码
      comCountycode: "", //区编码
    };
  },
  activated() {
    this.$store.commit("setTabBarShow", false);
  },
  //组件创建前调用的生命周期
  beforeCreate() {},
  deactivated() {
    this.$store.commit("setTabBarShow", true);
    this.formValidate = {
      province: "",
      county: "",
      province1: "",
      county1: "",
      city1: "",
      //身份证号码
      cardId: "",
      //密码
      mail: "",
      //确认密码
      mail1: "",
      city: "",

      //手机号
      mobile: "",
      yzm: "",
      yname: "",
      //性别
      sex: "",
      // 职称类别
      radio: 1,
      //姓名
      fullName: "",
      //执行地区
      workArea: "",
      //验证码
      checkCode: "",
      //执业范围
      jobName: "经营",
      //工作单位
      companyName: "",
      lei: "",
      educationBackground: "",
      //所学专业
      major: "",
      classify: "",
      ming: "",
      dizhi: "",
      //年龄
      age: "",
      //电话
      tel: "",
      //电子邮箱
      email: "",
      //邮寄地址
      address: "",
      //职务
      zhiwu: "",
      //邮编
      bian: "",
      //技术岗位
      gang: "",
      //开票类型
      kai: "",
      //发票抬头
      tai: "",
      //纳税人识别号
      hao: "",
    };
    this.qiyealidate = {
      //账号
      zh: "",
      //手机号
      sj: "",
      //负责人姓名
      fz: "",
      //密码
      mm: "",
      //性别
      sex: "",
      //确认密码
      qr: "",
      //单位名称
      dw: "",
      //单位地址
      dz: "",
      //所属行政区域
      qy: "",
      //单位电话
      dh: "",
      //邮政编码
      yb: "",
      //开票类型
      kp: "",
      //发票抬头
      fp: "",
      //纳税识别号
      ns: "",
    };
    
  },

  mounted() {
    this.queryProvince();
  },

  methods: {
    Check(e){
      let patrn = /^[0-9]*$/;
      if(e){
        if(patrn.test(e)){
        this.$Message.error("账号不能为纯数字")
      }
      } else{
        this.$Message.error("账号不能为空")
      }
    },
    checkRangeIdCard(e) {
      if(!e) return;
      checkRangeIdCard({ idCard:this.sm4Encrypt(e)}).then((res) => {
        console.log(res);
        if (res.data.code !== 200) {
          this.$Message.error(res.data.msg);
          this.mag1 = false
        } else {
          this.mag1 = true
          if (parseInt(e.substr(16, 1)) % 2 == 1) {
            this.formValidate.sex = "nan"
          } else {
            this.formValidate.sex = "nv"
          }
          console.log(this.formValidate.sex);
        }
      });
    },
    // onblur() {
    //   checkRangeMobile({
    //     mobile: this.formValidate.mobile,
    //   }).then((res) => {
    //     console.log(res);
    //     if (res.data.code == 500) {
    //       this.mag = false
    //     } else if(res.data.code==200){
    //       this.mag = true
    //     }
    //   });
    // },
    changesheng(e) {
        this.citiesArr = this.provinceArr[0].children;
        
    },
    changesheng1(e) {
        this.citiesArr1 = this.provinceArr1[0].children;
        
    },
    changeCity(e) {
      console.log(e);
      this.citiesArr.forEach((item, i) => {
        if (e == this.citiesArr[i].code) {
          this.countyArr = this.citiesArr[i].children;
          console.log(this.countyArr);
          this.comCitycode = this.citiesArr[i].code;
        }
      });
    },
    getpost(e) {
      console.log(e);
      this.countyArr.forEach((item, i) => {
        if (e == this.countyArr[i].code) {
          console.log(this.formValidate.bian);
          this.comCountycode = this.countyArr[i].code;
        }
      });
    },
    changeCity1(e) {
      console.log(e);
      this.citiesArr1.forEach((item, i) => {
        if (e == this.citiesArr1[i].code) {
          this.countyArr1 = this.citiesArr1[i].children;
          console.log(this.countyArr);
          this.comCitycode = this.citiesArr1[i].code;
        }
      });
    },
    getpost1(e) {
      console.log(e);
      this.countyArr1.forEach((item, i) => {
        if (e == this.countyArr1[i].code) {
          this.formValidate.bian = this.countyArr1[i].postCode;
          this.qiyealidate.yb = this.countyArr1[i].postCode;
          console.log(this.formValidate.bian);
          this.comCountycode = this.countyArr1[i].code;
        }
      });
    },
    queryProvince() {
      getCityList().then((res) => {
        console.log(res, "省");
        this.provinceArr = res.data.data;
        this.provinceArr1 = res.data.data;
        this.comProvincecode = this.provinceArr1[0].code;
        this.citiesArr1 = this.provinceArr1[0].children;
      });
    },
    gologin() {
      this.cur = 0
      this.num = 0
      this.$router.go(-1);
    },
    handleView() {
      this.visible = true;
    },
    handleRemove() {
      this.src = null;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件格式不正确，请选择jpg或png.",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件限制大小",
        desc: "文件大小不能超过2M",
      });
    },
    handleBeforeUpload(res) {
      console.log(res, "图片上传");
      this.src = res.data.data.imageUrl;
      console.log(this.uploadList);
    },
    cl() {
      this.cur = 0;
    },
    cl1() {
      this.cur = 1;
    },
    cahnge() {
      this.$forceUpdate();
    },
    cahnge1() {
      console.log(this.educationBackground);
      console.log(this.formValidate.sex);
    },
    onInput() {
      this.$forceUpdate();
    },
    focusChange(e) {
      this.showKeyboard = true;
      this.show = true;
    },
    onConfirm(value, index) {
      this.data.sex = value;
      this.showPicker = false;
    },
    //选择性别
    selectSex(e) {
      this.data;
    },
    //获取手机验证码
    getCode() {
      this.loading = false;
      let isCode = /^1[34578][0-9]{9}$/;
      console.log(this.formValidate.mobile);
      if (isCode.test(this.formValidate.mobile)) {
          if(this.codes != '获取验证码') {
            return this.$Message({
              type: 'warning',
              message: '请稍后再试'
            })
          }
          this.sendMessageToUser();
          const TIME_COUNT = 60;
        if (!this.timer) {
          this.flag = true;
          this.codes = TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.codes > 0 && this.codes <= TIME_COUNT) {
              this.codes--;
            } else {
              this.codes = "获取验证码";
              clearInterval(this.timer);
              this.timer = null;
              this.flag = false;
            }
          }, 1000);
        }
      } else {
        this.$message({
          message: "手机号格式不正确!",
          type: "warning",
        });
      }
    },
    getname(e) {
      uniqueUsername({ username: e }).then((res) => {
        console.log(res, "用户名");
        if (res.data.code == 200) {
          this.stopSubmit = false;
        } else {
          this.stopSubmit = true;
          this.$message.error("用户名重复");
        }
      });
    },
    sendMessageToUser() {
      sendMessageToUser(this.formValidate.mobile).then((r) => {
        console.log(r, "");
        this.isCode1 = r.data.data;
        if (r.data.code === 200) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        }
      });
    },
    isCardNo(cardId) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(cardId) === false) {
        this.$message({
          message: "身份证输入不合法",
          type: "success",
        });

        return false;
      }
    },
    //下一步
    nextze() {
      let iscardId = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (iscardId.test(this.formValidate.cardId)) {
       if(this.mag1){
          if (this.formValidate.mail.length !== 0) {
          if (this.formValidate.mail1.length !== 0) {
            if (this.formValidate.mail == this.formValidate.mail1) {
              this.$refs.formValidates.validate((valid) => {
                if (valid) {
                  this.num++;
                }
              });
            } else {
              this.$message({
                message: "两次密码不一致!",
                type: "warning",
              });
            }
          } else {
            this.$message({
              message: "确认密码不能为空!",
              type: "warning",
            });
          }
        } else {
          this.$message({
            message: "密码不能为空!",
            type: "warning",
          });
        }
       } else{
         this.$Message.error("身份证号码已被注册或者不合法")
       }
      } else {
        this.$message({
          message: "身份证号码格式不正确!",
          type: "warning",
        });
      }
      //    this.num = 2,
      //    this.cur = 0;
    },
    nextze2() {
      if (
        this.formValidate.fullName &&
        this.formValidate.mobile &&
        this.formValidate.sex &&
        this.formValidate.checkCode
      ) {
        if (this.isCode1 == this.formValidate.checkCode) {
          (this.num = 2), (this.cur = 0);
        } else [this.$message.warning("验证码错误")];
      } else {
        this.$message.warning("请完善信息");
      }
    },
    //上
    nextxiayibu() {
      if (this.formValidate.tai) {
        this.num++;
      } else {
        this.$Message.error("请完善信息");
      }
    },
    prevze() {
      if (this.num == 2) {
        this.num = 1;
      } else {
        this.num -= 1;
      }
      // this.num=2;
      // this.cur=0
    },
    onDelete(e) {
      this.data.checkCode = "e";
    },
    validator(val) {
      this.isID = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    // validators(e) {
    //   this.isCode = /^1[34578][0-9]{9}$/.test(e);
    //   return /^1[34578][0-9]{9}$/.test(e);
    // },
    // 个人提交注册
    sumbit() {
      if (this.cur == 0) {
        this.type = 0;
      } else {
        this.type = 1;
      }
      if (this.formValidate.sex == "nan") {
        this.sex = 1;
      } else {
        this.sex = 0;
      }
      let shengfen = ""
      let chengshi = ""
      let quxian = ""
      this.provinceArr.forEach((item,i)=>{
              if(this.comProvincecode==item.code){
                shengfen = item.text
                item.children.forEach((a,b)=>{
                  if(this.formValidate.city1==a.code){
                    chengshi = a.text
                    a.children.forEach((c,d)=>{
                      if(this.formValidate.county1==c.code){
                      quxian = c.text
                      }
                    })
                  }
                })
              }
            })
            console.log(shengfen,chengshi,quxian);
      let obj = {
        address: this.formValidate.address,
        county: quxian,
        city: chengshi,
        postalCode: this.formValidate.bian,
        province: shengfen,
      };
      
           let administrativeRegion = shengfen+chengshi+quxian
      let workArea =
        this.formValidate.province +
        this.formValidate.city +
        register({
          type: 0, //用户类型 0 为个人 1为企业
          idCard:this.sm4Encrypt(this.formValidate.cardId), //身份证
          password: md5(this.formValidate.mail), //密码
          fullName: this.formValidate.fullName, //用户姓名
          mobile:this.sm4Encrypt(this.formValidate.mobile) , //手机号
          sex: this.sex, //性别,
          jobId:this.formValidate.jobId,//执业范围Id
          jobName: this.formValidate.jobName, //执业范围
          checkCode: this.formValidate.checkCode, //验证码
          workArea: workArea, //执业地区
          mail: this.formValidate.email, //电子邮箱
          administrativeRegion: administrativeRegion, //省市区
          postCode: this.formValidate.bian,
          address: obj, //邮寄地址
          companyName: this.formValidate.companyName, //工作单位
          educationBackground: this.educationBackground,
          major: this.formValidate.major,
          comCity: this.formValidate.comCity,
          comCounty: this.formValidate.comCounty,
          comProvince: this.formValidate.comProvince,
        }).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$Message.success(res.data.msg);
            this.$router.push("/login");
            this.num = 0
            this.cur = 0
          } else {
            this.$Message.warning(res.data.msg);
          }
        });
    },
    nextzee() {
      let t = /^[1-9]\d{5}$/;
      if (this.formValidate.address && t.test(this.formValidate.bian)) {
        this.num = 2;
        this.cur = 0;
      } else {
        this.$Message.error("请完善信息");
      }
    },
    prevzee() {
      this.num = 1;
      this.cur = 0;
    },

    nextzer() {
      this.qiyealidate.dz = this.formValidate.city1 + this.formValidate.county1 +this.formValidate.province1
      if (this.qiyealidate.dw && this.qiyealidate.dz && this.qiyealidate.qy && this.qiyealidate.dh && this.qiyealidate.yb) {
        let patrn = /^[0-9]*$/;
        if(patrn.test(this.qiyealidate.zh)){
          this.$Message.error("账号不能为纯数字")
          return
        }
        if (this.stopSubmit) {
          this.$message.error("用户名重复");
          return;
        }
        if (this.qiyealidate.fz && this.qiyealidate.mm && this.qiyealidate.qr) {
        if (this.qiyealidate.mm == this.qiyealidate.qr) {
          this.cur = 1;
          register({
            type: 1, //用户类型 0 为个人 1为企业
            password: md5(this.qiyealidate.mm), //密码
            fullName: this.qiyealidate.fz, //负责人姓名
            // sex: this.sex, //性别
            workArea: this.qiyealidate.dz, //单位地址
            workPhone: this.qiyealidate.dh, //单位电话
            companyName: this.qiyealidate.dw, //单位名称
            administrativeRegion: this.qiyealidate.qy, //所属行政区域
            postCode: this.qiyealidate.yb, //邮政编码
            username: this.qiyealidate.zh,
          }).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$Message.success(res.data.msg);
              this.$router.push("/login");
              this.num = 0
              this.cur = 0
            } else {
              this.$Message.warning(res.data.msg);
            }
          });
        } else {
          this.type = 1;
        }
        // if (this.qiyealidate.sex == "nan") {
        //   this.sex = 1;
        // } else {
        //   this.sex = 0;
        // }
        // let obj2 = {
        //   invoiceType: this.qiyealidate.kai,
        //   invoiceRise: this.qiyealidate.fp,
        //   identifyNumber: this.qiyealidate.ns,
        //   mobile: this.qiyealidate.modile,
        // };
        // register({
        //   type: 1, //用户类型 0 为个人 1为企业
        //   password: md5(this.qiyealidate.mm), //密码
        //   fullName: this.qiyealidate.fz, //负责人姓名
        //   mobile: this.qiyealidate.sj, //负责人手机号
        //   sex: this.sex, //性别
        //   workArea: this.qiyealidate.dz, //单位地址
        //   workPhone: this.qiyealidate.dh, //单位电话
        //   companyName: this.qiyealidate.dw, //单位名称
        //   administrativeRegion: this.qiyealidate.qy, //所属行政区域
        //   postCode: this.qiyealidate.yb, //邮政编码
        //   username: this.qiyealidate.zh,
        //   invoice: obj2,
        // }).then((res) => {
        //   console.log(res);
        //   if (res.data.code == 200) {
        //     this.$Message.success(res.data.msg);
        //     this.$router.push("/login");
        //   } else {
        //     this.$Message.warning(res.data.msg);
        //   }
        // });
      } else {
        this.$message.warning("两次密码不一致");
      }
      } else {
        this.$message.warning("请完善信息");
      }
       
      // else {
      //   this.$message.warning("请完善信息");
      // }
    },
    prevzev() {
      this.rou = 0;
      this.cur = 1;
    },
    prevzeb() {
      this.rou = 1;
      this.cur = 1;
    },
    nextzeq() {},
    prevzev() {
      this.rou = 0;
      this.cur = 1;
    },
    prevzeb() {
      this.rou = 1;
      this.cur = 1;
    },
    // nextzew() {
    //   console.log(
    //     this.qiyealidate.kai && this.qiyealidate.fp && this.qiyealidate.ns
    //   );
    //   if (this.qiyealidate.mm == this.qiyealidate.qr) {
    //     if (this.cur == 0) {
    //       this.type = 0;
    //     } else {
    //       this.type = 1;
    //     }
    //     if (this.qiyealidate.sex == "nan") {
    //       this.sex = 1;
    //     } else {
    //       this.sex = 0;
    //     }
    //     let obj2 = {
    //       invoiceType: this.qiyealidate.kai,
    //       invoiceRise: this.qiyealidate.fp,
    //       identifyNumber: this.qiyealidate.ns,
    //       mobile: this.qiyealidate.modile,
    //     };
        
    //   } else {
    //     this.$message.warning("两次密码不一致");
    //   }
    // },
    prevzev() {
      this.rou = 0;
      this.cur = 1;
    },
    prevzeb() {
      this.rou = 1;
      this.cur = 1;
    },
    nextzeq() {},
    prevzev() {
      this.rou = 0;
      this.cur = 1;
    },
    prevzeb() {
      this.rou = 1;
      this.cur = 1;
    },
    // nextzew() {
    //   console.log(
    //     this.qiyealidate.kai && this.qiyealidate.fp && this.qiyealidate.ns
    //   );
    //   if (this.qiyealidate.mm == this.qiyealidate.qr) {
    //     if (this.cur == 0) {
    //       this.type = 0;
    //     } else {
    //       this.type = 1;
    //     }
    //     if (this.qiyealidate.sex == "nan") {
    //       this.sex = 1;
    //     } else {
    //       this.sex = 0;
    //     }
    //     let obj2 = {
    //       invoiceType: this.qiyealidate.kai,
    //       invoiceRise: this.qiyealidate.fp,
    //       identifyNumber: this.qiyealidate.ns,
    //       mobile: this.qiyealidate.modile,
    //     };
        
    //   } else {
    //     this.$message.warning("两次密码不一致");
    //   }
    // },
  },
  
  components: {
    Area,
  }
};
</script>

<style lang="less" scoped>
#home1 {
  background-image: url("../../../assets/img/login/loginbg.png");
  width: 1919px;
  height: 937px;
  background-size: 100% 100%;
  padding-top: 95px;
}
input {
  font-size: 20px;
}

.register_box {
  width: 1480px;
  height: 750px;
  background: #ffffff;
  box-shadow: 0px 0px 36px 18px rgba(170, 203, 255, 0.11);
  border-radius: 10px;
  margin-left: 200px;
  padding-top: 58px;
  padding-left: 60px;
}
.zcxingshi {
  height: 50px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  position: relative;
}

.gun {
  width: 27px;
  height: 8px;
  background: #3562e8;
  border-radius: 4px;
  position: absolute;
  left: 46px;
  bottom: 5px;
}
.gun1 {
  width: 27px;
  height: 8px;
  background: #3562e8;
  border-radius: 4px;
  position: absolute;
  left: 216px;
  bottom: 5px;
}

.bujinqi {
  width: 1300px;
  height: 70px;
  margin-top: 60px;
  margin-left: 50px;
}
// .qzhuce {
//   height: 500px;
//   border: red 1px solid;
// }

.xixin_zhuce {
  width: 500px;
  height: 500px;
  margin-left: 500px;
}

label {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.next_zhuce {
  width: 180px;
  height: 48px;
  background: #3562e8;
  border-radius: 8px;
  margin-top: -50px;
  margin-left: 580px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.prev_shangzhuce {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 673px;
}
.next_xiazhuce:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 44px;
  margin-left: 520px;
  cursor: pointer;
}
.next_xiazhuce {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  border: #3562e8 1px solid;
  text-align: center;
  line-height: 46px;
  margin-top: 44px;
  margin-left: 520px;
  cursor: pointer;
}
.prev_shangqiye {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 30px;
  margin-left: 606px;
  cursor: pointer;
}
.prev_shangqiye:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 30px;
  margin-left: 606px;
  cursor: pointer;
}

.next_xiaqiye:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 393px;
  cursor: pointer;
}
.next_xiaqiye {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 393px;
  cursor: pointer;
  border: 1px solid #3562e8;
}
.prev_shang:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 673px;
  cursor: pointer;
}
.prev_shang {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 673px;
  cursor: pointer;
}
.next_xia {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
  border: 1px solid #3562e8;
}
.next_xia:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
}
.next_xiaone:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;

  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  margin-left: 673px;
}
.next_xiaone {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  margin-left: 673px;
}
.prev_shangone:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border: 1px solid #3562e8;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
}
.prev_shangone {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border: 1px solid #3562e8;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
}
.prev_fapiao1:hover {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
  background: #3562e8;
}
.prev_fapiao1 {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
}

.prev_fapiao2 {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
}
.prev_fapiao2:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
}
.next_fapiao3 {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: -45px;
  margin-left: 403px;
  cursor: pointer;
}
.next_fapiao3:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -45px;
  margin-left: 403px;
  cursor: pointer;
}
.prev_fapiao:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 450px;
  cursor: pointer;
}
.prev_fapiao {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 450px;
  cursor: pointer;
}
.next_fapiao {
  width: 180px;
  height: 46px;
  border: 1px solid #3562e8;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 199px;
  cursor: pointer;
  margin-top: -44px;
  margin-left: 199px;
}
.next_fapiao:hover {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 199px;
  cursor: pointer;
  margin-top: -44px;
  margin-left: 199px;
}
#gerenfapiao {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  margin-left: 300px;
}
#qiyefapiao {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  margin-left: 300px;
}
.xixin_youji {
  margin-left: 100px;
}
.prev_fapiao[data-v-7bebb8ff] {
  margin-left: 366px;
}
.next_fapiao[data-v-7bebb8ff] {
  margin-left: 88px;
}
#bb {
  margin-left: 166px;
}
.shoujihao {
  margin-left: 44px;
}
.qiye_zhuce {
  margin-left: 111px;
}
#ge {
  color: #3562e8;
}
.cp {
  margin-left: 47px;
}
.formValidate {
  margin-top: 100px;
}
.mima {
  margin-top: 40px;
}
.mimaa {
  margin-top: 40px;
}
.shuru {
  width: 477px;
}
.yanz {
  width: 372px;
}
.bbtt {
  width: 90px;
  margin-left: 11px;
}
.xueli {
  width: 200px;
}
.zhenghsu {
  margin-top: -14px;
}
.kaipiaoa {
  width: 200px;
}
.formValidatee {
  margin-left: 150px;
}
.startdataa {
  margin-left: 80px;
}

.register_ing {
  width: 80px;
  height: 40px;
}

.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>